"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLabels = void 0;
var _react = require("react");
var _CetComponentsProvider = require("../providers/CetComponentsProvider");
const useLabels = function () {
  let {
    labels,
    device,
    gender
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    labels: {
      he: {},
      ar: {},
      en: {}
    }
  };
  const {
    language
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const getLabel = (0, _react.useCallback)(labelId => {
    const value = labels[language][`${labelId}_${device}_${gender}`] ?? labels[language][`${labelId}_${device}`] ?? labels[language][`${labelId}_${gender}`] ?? labels[language][`${labelId}`] ?? '';
    return value;
  }, [device, gender, labels, language]);
  return getLabel;
};
exports.useLabels = useLabels;